
import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from '../config';
import "./reviews.css";
import api from '../api/api.js';

import StarRating from "./StarRating";

const BusinessReview = ({ apiEndpoint, userId, businessId }) => {
  const [reviewData, setReviewData] = useState({
    reviewId: 0,
    businessId: 21,
    userId: 62,
    jobId: 1,
    businessName: "Excel Electrical",
    ratingQuality: 0,
    ratingService: 0,
    ratingCommunication: 0,
    ratingPromptness: 0,
    ratingCompletion: 0,
    overallRating: 0,
    description: "",
    myStatus: "draft",
  });

  const handleRatingChange = (field, rating) => {
    setReviewData({ ...reviewData, [field]: rating });
    console.log(`Rating for ${field} set to: ${rating}`);
  };

  const handleSaveDraft = () => {
    const currentDateTime = new Date().toISOString(); // Format in ISO format

    api.post(`/api/businessreview/save`, { ...reviewData, 
      myStatus: "draft",
      dateAdded: currentDateTime, 
      dateModified: currentDateTime 
    })
      
      .then(response => {

        if (response.data && response.data.reviewId) {
          setReviewData(prev => ({ ...prev, reviewId: response.data.reviewId }));
        }
        console.log(`New Rating id ${response.data.reviewId}`);

        alert("Review saved as draft!");
      })
      .catch(error => {
        console.error("Error saving review as draft", error);
      });
  };

  const handlePublish = () => {
    const currentDateTime = new Date().toISOString(); // Format in ISO format

    api.post(`/api/businessreview/publish`, { ...reviewData, 
      myStatus: "published",
      dateAdded: currentDateTime, 
      dateModified: currentDateTime 
    })
      
      
      .then(response => {
        alert("Review published!");
      })
      .catch(error => {
        console.error("Error publishing review", error);
      });
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0px 0px 10px rgba(0,0,0,0.1)' }}>
      <h2 className="text-xl font-bold mb-4">Review of {reviewData.businessName}</h2>
      <p className="font-semibold text-gray-600">John Smith</p>
      <p className="text-gray-500 mb-6">Home Owner</p>
      <p className="text-xl font-bold mb-4">Give overall rating to: {reviewData.businessName}</p>
      
      <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}> 
        <StarRating 
          rating={reviewData.overallRating} 
          onChange={(rating) => handleRatingChange("overallRating", rating)} 
        />
      </div>
      
      <div style={{ marginTop: '20px', }}> 
        <label style={{ width: '150px' }}>Quality of work</label> 
        <StarRating 
          rating={reviewData.ratingQuality} 
          onChange={(rating) => handleRatingChange("ratingQuality", rating)} 
        />
      </div>
      
      <div style={{ marginTop: '20px' }}>
        <label>Service</label>
        <StarRating
          rating={reviewData.ratingService}
          onChange={(rating) => handleRatingChange("ratingService", rating)}
        />
      </div>
      <div style={{ marginTop: '20px' }}>
        <label>Communication</label>
        <StarRating
          rating={reviewData.ratingCommunication}
          onChange={(rating) => handleRatingChange("ratingCommunication", rating)}
        />
      </div>
      <div style={{ marginTop: '20px' }}>
        <label>Promptness</label>
        <StarRating
          rating={reviewData.ratingPromptness}
          onChange={(rating) => handleRatingChange("ratingPromptness", rating)}
        />
      </div>
      <div style={{ marginTop: '20px' }}>
        <label>Completion of work</label>
        <StarRating
          rating={reviewData.ratingCompletion}
          onChange={(rating) => handleRatingChange("ratingCompletion", rating)}
        />
      </div>
      <div style={{ marginTop: '20px' }}>
        <textarea
          style={{ width: '100%', border: '2px solid #ccc', padding: '10px', borderRadius: '8px', marginTop: '10px' }}
          placeholder="Share details of your experience"
          value={reviewData.description}
          onChange={(e) => {
            setReviewData({ ...reviewData, description: e.target.value });
            console.log(`Description updated: ${e.target.value}`);
          }}
        />
      </div>
      <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'space-between' }}>
        <button
          style={{ backgroundColor: '#333', color: 'white', padding: '10px 20px', borderRadius: '8px' }}
          onClick={handleSaveDraft}
        >
          Save Draft
        </button>
        <button
          className="bg-gray-800 text-black px-6 py-3 rounded"
          onClick={handlePublish}
        >
          Publish
        </button>
      </div>
    </div>
  );
};

export default BusinessReview;
